var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"arrow-right","d":"m10.5 14c0.10417 0 0.1875-0.041666 0.25-0.125l4.125-4.125c0.083334-0.0625 0.125-0.14583 0.125-0.25s-0.041666-0.1875-0.125-0.25l-4.125-4.125c-0.0625-0.083333-0.14583-0.125-0.25-0.125s-0.1875 0.041667-0.25 0.125l-0.625 0.59375c-0.083333 0.083333-0.125 0.17708-0.125 0.28125s0.041667 0.1875 0.125 0.25l2.5312 2.4375h-10.781c-0.10417 0-0.19271 0.036458-0.26562 0.10938s-0.10938 0.16146-0.10938 0.26562v0.875c0 0.10417 0.036458 0.19271 0.10938 0.26562s0.16146 0.10938 0.26562 0.10938h10.781l-2.5312 2.4375c-0.083333 0.0625-0.125 0.14583-0.125 0.25s0.041667 0.19792 0.125 0.28125l0.625 0.59375c0.0625 0.083334 0.14583 0.125 0.25 0.125z","fill":"#004E7D"}));
}

ArrowRight.defaultProps = {"version":"1.1","width":"16","height":"18","viewBox":"0 0 16 18"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
